import { useMemo } from "react";
import {
    getAreaListThunk,
    getCatalogExportThunk,
    getKpiGetProgressThunk,
    getKpiGetSalaryToPayThunk,
} from "tm-shared/api";
import { warmupImages } from "tm-shared/utils";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { getFileUrl, getKpiTargetDate } from "@/utils";

type InitRetryCommand = {
    title: string;
    run: () => Promise<unknown>;
};

export const useInitRetryRequests = () => {
    const dispatch = useAppDispatch();
    const userId = useAppSelector((s) => s.user.id);

    return useMemo<Partial<Record<string, InitRetryCommand>>>(() => {
        const kpiTargetDate = getKpiTargetDate();

        const commonKpiParams = {
            employeeId: userId,
            targetDate: kpiTargetDate,
        };

        return {
            getAreaListThunk: {
                title: "Отримання доступних регіонів",
                run: () => dispatch(getAreaListThunk()).unwrap(),
            },
            getCatalogExportThunk: {
                title: "Завантаження каталогу",
                run: async () => {
                    const { result } = await dispatch(
                        getCatalogExportThunk(),
                    ).unwrap();
                    const imageUrls = result.products
                        .map((p) => p.params.image.value.map(getFileUrl))
                        .flat();
                    warmupImages(imageUrls);
                },
            },
            getKpiGetSalaryToPayThunk: {
                title: "Завантаження зарплати",
                run: () =>
                    dispatch(
                        getKpiGetSalaryToPayThunk(commonKpiParams),
                    ).unwrap(),
            },
            getKpiGetProgressThunk: {
                title: "Завантаження прогресу KPI",
                run: () =>
                    dispatch(getKpiGetProgressThunk(commonKpiParams)).unwrap(),
            },
        };
    }, [dispatch, userId]);
};
